(function () {
  'use strict';
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* tema slider'ı (carousel-slider) altına kaydırma noktaları */
  function initDots(d) {
    if (d._slInit) return;
    var slider = document.getElementById(d.getAttribute('data-sl-dots'));
    if (!slider) return;
    d._slInit = true;
    var pages = 0;

    function build() {
      d.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sl-dot';
        b.setAttribute('aria-label', (i + 1) + '/' + pages);
        (function (idx) {
          b.addEventListener('click', function () {
            slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
          });
        })(i);
        d.appendChild(b);
      }
    }

    function update() {
      var w = slider.clientWidth;
      if (!w) return;
      var np = Math.max(1, Math.ceil((slider.scrollWidth - 4) / w));
      if (np !== pages) { pages = np; build(); }
      d.hidden = pages < 2;
      var cur = Math.min(pages - 1, Math.round(slider.scrollLeft / w));
      qsa(d, '.sl-dot').forEach(function (dot, i) {
        if (i === cur) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    d._slUpdate = update;
    d.hidden = true;
    update();
  }

  function updateAll() { qsa(document, '[data-sl-dots]').forEach(function (d) { if (d._slUpdate) d._slUpdate(); }); }

  /* mobil tab satırı: yerel yatay kaydırma kapalı (CSS), yalnızca belirgin yatay parmak hareketi satırı kaydırır.
     Dikey kaydırmada satır yatayda oynamaz, uçlarda esneme olmaz. */
  function initTabScroll(row) {
    if (row._slScroll) return;
    row._slScroll = true;
    var sx = 0, sy = 0, sl = 0, lock = null, lastX = 0, lastT = 0, vel = 0, raf = 0;
    function maxLeft() { return Math.max(0, row.scrollWidth - row.clientWidth); }
    function clamp(n) { return Math.min(maxLeft(), Math.max(0, n)); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    row.addEventListener('touchstart', function (e) {
      stop();
      var t = e.touches[0];
      sx = lastX = t.clientX; sy = t.clientY; sl = row.scrollLeft; lock = null; vel = 0; lastT = e.timeStamp;
    }, { passive: true });
    row.addEventListener('touchmove', function (e) {
      var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (lock === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        lock = Math.abs(dx) > Math.abs(dy) * 1.5 ? 'x' : 'y';
      }
      if (lock !== 'x') return;
      var dt = Math.max(1, e.timeStamp - lastT);
      vel = (lastX - t.clientX) / dt;
      lastX = t.clientX; lastT = e.timeStamp;
      row.scrollLeft = clamp(sl - dx);
    }, { passive: true });
    row.addEventListener('touchend', function () {
      if (lock !== 'x' || Math.abs(vel) < 0.05) return;
      var v = vel * 16;
      (function step() {
        v *= 0.95;
        if (Math.abs(v) < 0.5) { raf = 0; return; }
        var n = row.scrollLeft + v;
        row.scrollLeft = clamp(n);
        if (n < 0 || n > maxLeft()) { raf = 0; return; }
        raf = requestAnimationFrame(step);
      })();
    }, { passive: true });
    row.addEventListener('touchcancel', function () { lock = null; }, { passive: true });
  }

  function initTabs(root) {
    var tabs = qsa(root, '[role="tab"]');
    var panels = qsa(root, '[role="tabpanel"]');
    var viewAll = root.querySelector('[data-sl-viewall]');
    var tabRow = root.querySelector('.sl-tabs');
    function reveal(t) {
      if (!tabRow || tabRow.scrollWidth <= tabRow.clientWidth) return;
      var l = t.offsetLeft, r = l + t.offsetWidth, v = tabRow.scrollLeft, w = tabRow.clientWidth;
      if (l < v + 16) tabRow.scrollTo({ left: Math.max(0, l - 16), behavior: 'smooth' });
      else if (r > v + w - 16) tabRow.scrollTo({ left: r - w + 16, behavior: 'smooth' });
    }
    function activate(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
      if (viewAll && !viewAll.hasAttribute('data-fixed') && t.getAttribute('data-url')) viewAll.href = t.getAttribute('data-url');
      reveal(t);
      window.dispatchEvent(new Event('resize'));
      setTimeout(updateAll, 60);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t); }); });
  }

  /* kampanya slider: otomatik geçiş, noktalar, kaydırarak geçiş */
  function initHero(h) {
    var slides = qsa(h, '.sl-slide');
    var dots = qsa(h, '[data-sl-dot]');
    var i = 0, timer = null;
    var speed = (parseFloat(h.getAttribute('data-speed')) || 5) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { go(i + 1); }, speed);
    }
    dots.forEach(function (t, k) { t.addEventListener('click', function (e) { e.preventDefault(); go(k); start(); }); });
    h.addEventListener('mouseenter', stop);
    h.addEventListener('mouseleave', start);
    var sx = null;
    h.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (Math.abs(dx) > 45) { go(i + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    go(0);
    start();
  }

  function init(root) {
    qsa(root, '[data-sl-tabs]').forEach(function (el) { if (!el._slTabs) { el._slTabs = true; initTabs(el); } });
    qsa(root, '.sl-tabs').forEach(initTabScroll);
    qsa(root, '[data-sl-dots]').forEach(initDots);
    qsa(root, '[data-sl-hero]').forEach(function (el) { if (!el._slHero) { el._slHero = true; initHero(el); } });
  }

  function boot() { init(document); setTimeout(updateAll, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { setTimeout(updateAll, 100); });
  window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
